import { Grid, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { ResultField } from "@/modules/irohana-components/elements/ResultField";
import { Button } from "@/modules/irohana-components/elements/Button";
import { FooterActionBar } from "@/modules/irohana-components/elements/FooterActionBar";
import { AppRoutes } from "@/routes/config";
import { IconEditor } from "@/assets/icons";
import { TGetOrganizationDto } from "@/api/services/main/organization/dtos/get-organization.dto";

// body14Semi line-height (150% of 14px). Reserve one line so empty values keep the
// same height as filled ones — otherwise the divider of an empty field in a row sits
// higher than its filled neighbour and the underlines look misaligned.
const valueSx = { minHeight: "21px" };

/** Joins 都道府県・市区町村・町名丁目番地号等 into a single 所在地 line. */
const buildLocation = (data: TGetOrganizationDto): string => {
  return [data.province, data.municipality, data.addressLine].filter(Boolean).join("");
};

type TOrganizationDetailPageProps = {
  data: TGetOrganizationDto;
};

export const OrganizationDetailPage = ({ data }: TOrganizationDetailPageProps) => {
  const navigate = useNavigate();

  return (
    <Stack gap={4}>

      <InnerBox title="組織情報" sx={{ borderRadius: "0 0 8px 8px" }}>
        <Grid container rowSpacing={2} columnSpacing={3} mt={-2}>
          <Grid item xs={12}>
            <ResultField label="組織名" value={data.name} valueSx={valueSx} />
          </Grid>
          <Grid item xs={12}>
            <ResultField label="所在地" value={buildLocation(data)} valueSx={valueSx} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ResultField label="電話番号" value={data.phone} valueSx={valueSx} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ResultField label="インボイス登録番号" value={data.invoiceRegistrationNumber} valueSx={valueSx} />
          </Grid>
          <Grid item xs={12}>
            {/* 振込先口座情報 is free-text and may span multiple lines — preserve line breaks. */}
            <ResultField label="振込先口座情報" value={data.bankAccount} valueSx={{ ...valueSx, whiteSpace: "pre-wrap" }} />
          </Grid>
        </Grid>
      </InnerBox>

      <FooterActionBar>
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <Button variant="outline" onClick={() => navigate(AppRoutes.organizationBusinessEdit)} startIcon={<IconEditor />}>
            編集
          </Button>
        </Stack>
      </FooterActionBar>
    </Stack>
  );
};
